/* The picture is permanent. Download after its first paint; reveal only a playing frame. */
(function () {
  'use strict';
  if (window.IDGHeroFilm) { window.IDGHeroFilm.init(document); return; }
  var controllers = new Map();

  function mount(hero) {
    var film = hero.querySelector('.idg-hbg-film');
    var video = film && film.querySelector('video');
    if (!video || controllers.has(hero)) return;
    var picture = hero.querySelector('picture img');
    var dots = hero.querySelector('.idg-hbg-dots');
    var buttons = dots ? dots.querySelectorAll('button') : [];
    var toggle = hero.querySelector('.idg-hbg-toggle');
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var connection = navigator.connection;
    var auto = !connection || (!connection.saveData && !/^(slow-)?2g$/.test(connection.effectiveType));
    var rotate = dots && dots.dataset.rotate !== '0';
    var alive = true, posterReady = false, hydrated = false, failed = false;
    var inview = !window.IntersectionObserver, wanted = true, stopped = false;
    var pending = false, generation = 0, frame = null, timer = null, delay = null;
    var listeners = [];
    function on(target, event, fn) {
      target.addEventListener(event, fn);
      listeners.push(function () { target.removeEventListener(event, fn); });
    }
    function active() { return alive && inview && !document.hidden && !motion.matches; }
    function mark(index) {
      buttons.forEach(function (button, i) {
        button.classList.toggle('idg-cur', i === index);
        button.setAttribute('aria-pressed', String(i === index));
        var bar = button.querySelector('b');
        if (bar) { bar.style.transition = 'none'; bar.style.transform = i === index ? 'scaleX(1)' : 'scaleX(0)'; }
      });
    }
    function label() {
      if (toggle) toggle.textContent = toggle.dataset[stopped || !auto ? 'play' : 'pause'];
    }
    function pause() {
      generation++; pending = false;
      clearTimeout(timer); timer = null;
      if (frame !== null && video.cancelVideoFrameCallback) video.cancelVideoFrameCallback(frame);
      frame = null;
      video.pause();
    }
    function schedule(index) {
      clearTimeout(timer);
      if (!rotate || !active() || stopped || failed) return;
      var hold = Number(dots.dataset[index === 0 ? 'vhold' : 'ihold']) || (index === 0 ? 16 : 7);
      timer = setTimeout(function () { select(index !== 0); }, Math.max(1, hold) * 1000);
    }
    function fallback() {
      pause(); film.classList.remove('idg-on'); mark(1);
    }
    function fail() { if (!hydrated) return; failed = true; fallback(); if (toggle) toggle.hidden = true; }
    function play() {
      if (!active() || !posterReady || !wanted || stopped || !auto || failed || pending) return;
      if (!hydrated) {
        video.querySelectorAll('source[data-src]').forEach(function (source) { source.src = source.dataset.src; });
        video.muted = true; video.load(); hydrated = true;
      }
      pending = true;
      var attempt = ++generation;
      function valid() { return attempt === generation && active() && wanted && !stopped && !failed; }
      function reveal() {
        frame = null;
        if (!valid() || video.paused || video.readyState < 2 || !video.videoWidth) return;
        pending = false; film.classList.add('idg-on'); mark(0);
        if (toggle) toggle.hidden = false;
        label(); schedule(0);
      }
      Promise.resolve(video.play()).then(function () {
        if (!valid()) return;
        if (video.requestVideoFrameCallback) frame = video.requestVideoFrameCallback(reveal);
        else requestAnimationFrame(function () { requestAnimationFrame(reveal); });
      }).catch(function () {
        if (attempt !== generation || !alive) return;
        stopped = true; fallback(); label();
        if (toggle) toggle.hidden = false;
      });
    }
    function select(showVideo) {
      wanted = showVideo; pause();
      if (showVideo) play();
      else { film.classList.remove('idg-on'); mark(1); schedule(1); }
    }
    function sync() {
      if (!active()) { pause(); if (motion.matches) fallback(); return; }
      if (wanted) play(); else schedule(1);
    }
    on(video, 'error', fail);
    // Source errors do not bubble to video when every <source> fails.
    var badSources = new Set();
    video.querySelectorAll('source').forEach(function (source) {
      on(source, 'error', function () {
        if (!hydrated) return;
        badSources.add(source);
        if (badSources.size === video.querySelectorAll('source').length) fail();
      });
    });
    on(document, 'visibilitychange', sync);
    on(motion, 'change', sync);
    buttons.forEach(function (button) {
      on(button, 'click', function () { auto = true; stopped = false; label(); select(button.dataset.idgDot === '0'); });
    });
    if (toggle) on(toggle, 'click', function () {
      if (stopped || !auto) { auto = true; stopped = false; wanted = true; play(); }
      else { stopped = true; pause(); }
      label();
    });
    var observer = window.IntersectionObserver && new IntersectionObserver(function (entries) {
      inview = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.12;
      sync();
    }, { threshold: [0, 0.12] });
    if (observer) observer.observe(hero);
    mark(1); label();
    if (toggle && !auto && !motion.matches) toggle.hidden = false;
    function picturePainted() {
      // Two frames let the decoded, high-priority image paint before any media request.
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        if (!alive) return;
        delay = setTimeout(function () { posterReady = true; sync(); }, 350);
      }); });
    }
    function pictureLoaded() {
      if (picture && picture.decode) picture.decode().catch(function () {}).then(picturePainted);
      else picturePainted();
    }
    if (!picture || picture.complete) pictureLoaded();
    else { on(picture, 'load', pictureLoaded); on(picture, 'error', picturePainted); }
    controllers.set(hero, function () {
      alive = false; pause(); clearTimeout(delay);
      if (observer) observer.disconnect();
      listeners.forEach(function (off) { off(); });
      video.querySelectorAll('source[src]').forEach(function (source) { source.removeAttribute('src'); });
      video.load(); controllers.delete(hero);
    });
  }
  function init(root) { root.querySelectorAll('.idg-hero').forEach(mount); }
  window.IDGHeroFilm = { init: init };
  onReady();
  function onReady() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
    else init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (destroy, hero) { if (event.target.contains(hero)) destroy(); });
  });
})();
